<template>
  <a-drawer
    :width="fullscreen ? '100%' : 1080"
    placement="right"
    :closable="false"
    :visible="visible"
    :body-style="{ padding: 0, height: '100%' }"
    @close="onClose"
  >
  <a-spin tip="正在分析当前页面..." :spinning="capturing">
    <a-layout class="ai-assistant">
      <a-layout-sider :width="250" style="border-right: 1px solid #E5E8EB;background-color: #EDF3FA;">
        <ai-assistant-sider />
      </a-layout-sider>
      <a-layout-sider v-show="agentsShow" :width="200" style="border-right: 1px solid #E5E8EB;background-color: #EDF3FA;">
        <ai-assistant-agents />
      </a-layout-sider>
      <ai-assistant-session v-show="session" />
      <ai-assistant-agent v-show="userAgent" />
      <div v-if="close" class="ai-assistant__mask">
        <div class="ai-assistant__mask__tips">通信连接已断开</div>
        <a-button type="primary" @click="setup">点击重连</a-button>
      </div>
    </a-layout>
  </a-spin>
  </a-drawer>
</template>

<script>
import { mapGetters } from 'vuex'
import AiAssistantSider from './AiAssistantSider'
import AiAssistantSession from './AiAssistantSession'
import AiAssistantAgents from './AiAssistantAgents'
import AiAssistantAgent from './AiAssistantAgent'
import { captureScreenshot } from '@/utils/screenshot'
export default {
  name: 'AiAssistantDrawer',
  components: {
    AiAssistantSider,
    AiAssistantSession,
    AiAssistantAgents,
    AiAssistantAgent
  },
  data () {
    return {
      capturing: false,
      visible: false,
      aiModel: 'DeepSeek-V3',
      isDeepSeek: false,
      isNetwork: false,
      chats: [],
      inputValue: '',
      isStreaming: false,
      abortController: null
    }
  },
  computed: {
    ...mapGetters('aiAssistant', [
      'fullscreen',
      'sessions',
      'session',
      'session_id',
      'agentsShow',
      'userAgent',
      'close',
      'agent_id',
      'user_agent_id',
      '$aiHttp'
    ]
  ),
  ...mapGetters(['activePane'])
  },
  methods: {
    setup () {
      this.$store.dispatch('aiAssistant/setup')
    },
    init () {
      // 获取提示词列表
      this.$store.dispatch('aiAssistant/getPrompts')
      // 获取智能体列表
      this.$store.dispatch('aiAssistant/getAgents')
      // 获取已启用智能体列表
      this.$store.dispatch('aiAssistant/getUserAgents')
      // 获取智能体配置
      // 获取配额
      this.$store.dispatch('aiAssistant/getQuota')
      // 获取模型列表
      this.$store.dispatch('aiAssistant/getModels')
      // 获取历史会话列表
      this.$store.dispatch('aiAssistant/getSessions')
    },
    open (needCaptureScreen = false) {
      this.visible = true
      this.$store.dispatch('aiAssistant/loadFromCache')
      if (!this.sessions || !this.sessions.length) {
        this.$store.dispatch('aiAssistant/addSession')
      }
      setTimeout(() => {
        if (!this.session_id && !this.activePane.agentId && this.sessions[0]) {
          this.$store.dispatch('aiAssistant/setSessionId', this.sessions[0].session_id)
        }
        if (needCaptureScreen && !this.activePane.agentId) {
          this.capturing = true
          this.handleScreenshot()
        }
      }, 200)
    },
    async handleScreenshot () {
      try {
        // 执行截图
        const result = await captureScreenshot()
        // 上传截图到服务器
        await this.uploadScreenshot(result.blob)

        this.capturing = false
      } catch (error) {
        this.capturing = false
        console.error('截图失败:', error)
      }
    },
    /**
     * 上传截图到服务器
     * @param {Blob} blob - 截图的Blob对象
     * @returns {Promise<Object>} - 上传结果
     */
    async uploadScreenshot (blob) {
      try {
        // 创建FormData对象
        const formData = new FormData()
        formData.append('FILE', blob, `screenshot_${new Date().toISOString().replace(/[:.]/g, '-')}.jpg`)
        // 上传图片
        const { data } = await this.$aiHttp({
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          method: 'post',
          url: '/api/v1/agent/image-upload',
          data: formData
        })
        // 如果上传成功，可以在这里处理后续逻辑
        if (data.message === 'success') {
          // 发送图片URL到AI助手
          this.sendImageToAssistant(data.data.oss_url)
        }
      } catch (error) {
        console.error('截图上传失败:', error)
        this.$message.error('页面分析失败')
        throw error
      }
    },
    /**
     * 发送图片到AI助手
     * @param {String} imageUrl - 图片URL
     */
    sendImageToAssistant (imageUrl) {
      // 获取当前会话ID
      if (!this.session_id) {
        console.error('没有活动的会话')
        return
      }
     const message = this.activePane.topicList && this.activePane.topicList.length ? this.activePane.topicList[0].topicContent : '我是跨境电商卖家，请帮我分步骤详细分析和总结与经营数据相关的信息'
     console.log(message, 34344434)
     // 发送消息到AI助手，包含图片URL
      this.$store.dispatch('aiAssistant/sendMessage', {
        method: 'message',
        data: {
          session_id: this.session_id,
          message,
          images: [imageUrl]
        }
      })
    },
    onClose () {
      this.visible = false
    }
  },
  mounted () {
    this.$store.dispatch('aiAssistant/setup')
      .then(() => {
        // 初始化
        console.log('==== 初始化 ====')
        this.init()
      })
      .catch((error) => {
        console.log(error)
      })
  }
}
</script>

<style lang="less" scoped>
.ai-assistant.home-ant-layout {
  height: 100vh;
  position: relative;
}
.ai-assistant__mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.ai-assistant__mask__tips {
  margin-bottom: 10px;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 28px;
  text-align: center;
}
</style>
